import axios from "axios";
import config from "../../../config";

const getAuthToken = () => {
  return (
    localStorage.getItem("token") ||
    localStorage.getItem("accessToken") ||
    localStorage.getItem("authToken") ||
    ""
  );
};

const apiClient = axios.create({
  baseURL: config.API_URL,
});

apiClient.interceptors.request.use((request) => {
  const token = getAuthToken();
  if (token) {
    request.headers.Authorization = `Bearer ${token}`;
  }
  return request;
});

export { apiClient };
